<!-- Единая карточка read-only секции с заголовком, иконкой и слотами действий -->
<template>
  <div class="info-card">
    <div class="card-header">
      <div v-if="$slots.icon" class="card-icon">
        <slot name="icon" />
      </div>
      <h4 class="card-title"><BaseSectionHeader :title="title" :icon="$slots.icon ? null : icon" :count="count" /></h4>
      <div v-if="$slots.actions" class="card-actions">
        <slot name="actions" />
      </div>
    </div>
    <div class="card-content">
      <slot />
    </div>
    <div v-if="$slots.footer" class="card-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseInfoCard",
  props: {
    icon: { type: String, default: null },
    title: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style scoped>
.info-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  overflow: visible;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: var(--base-in-indent);
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.card-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--color-dark);
  flex: 1;
}

.card-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.card-content {
  flex: 1;
  padding: 0 var(--base-in-indent) var(--base-in-indent);
}

.card-footer {
  margin-top: auto;
  padding: 0 var(--base-in-indent) var(--base-in-indent);
}

.card-footer :slotted(*) {
  width: 100%;
}

@media (max-width: 520px) {
  .card-header {
    flex-wrap: wrap;
  }

  .card-actions {
    width: 100%;
    justify-content: flex-start;
    padding-left: 42px;
  }
}
</style>
